export default __webpack_public_path__ + "static/media/basketball2.9ebfa979.png";